swiper {

    position: relative;
    .swiper-inner {
      width: 100%;
      position: relative;
      height: 100%;
      overflow: hidden;
    }

    .swiper-container {
      .swiper-wrapper {
      }
    }
}
